import request from '@/utils/request'; // 最开始的 大屏数据

export function getLagerData(data) {
  return request({
    url: '/data/homepage_summary',
    method: 'get',
    params: data
  });
}